// extracted by mini-css-extract-plugin
export default {"option":"applications-components-HeaderApp-components-Search-option-module__option","optionFocused":"applications-components-HeaderApp-components-Search-option-module__optionFocused","type":"applications-components-HeaderApp-components-Search-option-module__type","typeExistingDesign":"applications-components-HeaderApp-components-Search-option-module__typeExistingDesign","typeOwnDesign":"applications-components-HeaderApp-components-Search-option-module__typeOwnDesign"};
    if(module.hot) {
      // 1782397803609
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  